import type { FileObject } from "../types/FileObject"
import type { FileProvider } from "../types/FileProvider"
import { CreateSingleton } from "@pdfking/tfunc"
import { BlobUrl } from "@pdfking/workflow/actions/pdfengine/BlobUrl"
import track_promise from "@pdfking/workflow/utils/track_promise"
import get_filedata from "../naming/get_filedata"

export default ({
  factory,
  file_meta,
  path,
}: {
  factory: FileProvider
  file_meta?: Record<string, string>
  path: string
}): FileObject => {
  const start = () => (object.loading = true)
  const finish = () => (object.loading = false)

  const get_file = CreateSingleton(() => track_promise(factory, start, finish))
  const get_url = CreateSingleton(() =>
    track_promise(
      () =>
        get_file()
          .then(BlobUrl)
          .then(url => (object.url = url)),
      start,
      finish
    )
  )

  const filedata = get_filedata(path)

  const object: FileObject = {
    file_meta: file_meta ?? {},

    get_file,
    get_url,

    loading: false,

    get name() {
      // to be removed
      throw new Error("name is not available")
    },
    path,
    short_name: `${filedata.basename}.${filedata.ext}`,

    url: undefined,

    ...filedata,
  } as FileObject

  return object
}
